import { GuidePlayerEvent } from './types';

export type GuidePlayerListener = (event: GuidePlayerEvent) => void;

/** Tiny synchronous fan-out for player lifecycle events. */
export function createGuidePlayerEventBus() {
    const listeners = new Set<GuidePlayerListener>();
    return {
        subscribe(listener: GuidePlayerListener) {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        emit(event: GuidePlayerEvent) {
            listeners.forEach((listener) => listener(event));
        },
    };
}
